import { JurisdictionOverrideModel } from "./../models/jurisdiction-override-model";
import { JurisdictionFilterView } from "./jurisdiction-filter";
import { FacetModel } from "./../models/facet";
import Marionette from "../../shared/marionette-mustache";
import { SearchModel } from "../../search/models/search";
import { CategoryFilterView } from "../../search/views/category-filter";
import { backboneViewProperties } from "../../decorators/backbone-properties";

import { autoinject } from "aurelia-dependency-injection";

const dom = {
};

@backboneViewProperties({
    tagName: "ul",
    childView: JurisdictionFilterView,
})
export class JurisdictionFiltersView extends Marionette.CollectionView<JurisdictionOverrideModel, JurisdictionFilterView> {

    constructor(options?) {
        super(options);
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/jurisdiction-filters.ts